import { FC } from "react"
import { Typography, TypographyProps } from "@material-ui/core"
import React from "react"

export const H1: FC<TypographyProps> = (props) => (
  <Typography variant="h1" {...props}>
    {props.children}
  </Typography>
)

export const H2: FC<TypographyProps> = (props) => (
  <Typography variant="h2" {...props}>
    {props.children}
  </Typography>
)

export const H3: FC<TypographyProps> = (props) => (
  <Typography variant="h3" {...props}>
    {props.children}
  </Typography>
)

export const H4: FC<TypographyProps> = (props) => (
  <Typography variant="h4" {...props}>
    {props.children}
  </Typography>
)

export const H5: FC<TypographyProps> = (props) => (
  <Typography variant="h5" {...props}>
    {props.children}
  </Typography>
)

export const H6: FC<TypographyProps> = (props) => (
  <Typography variant="h6" {...props}>
    {props.children}
  </Typography>
)

export const Subtitle1: FC<TypographyProps> = (props) => (
  <Typography variant="subtitle1" {...props}>
    {props.children}
  </Typography>
)

export const Subtitle2: FC<TypographyProps> = (props) => (
  <Typography variant="subtitle2" {...props}>
    {props.children}
  </Typography>
)
export const Body1: FC<TypographyProps> = (props) => (
  <Typography variant="body1" {...props}>
    {props.children}
  </Typography>
)

export const Body2: FC<TypographyProps> = (props) => (
  <Typography variant="body2" {...props}>
    {props.children}
  </Typography>
)

export const AllTypographies: FC = () => (
  <div>
    <H1>Header 1</H1>
    <H2>Header 2</H2>
    <H3>Header 3</H3>
    <H4>Header 4</H4>
    <H5>Header 5</H5>
    <H6>Header 6</H6>
    <Subtitle1>Subtitle 1</Subtitle1>
    <Subtitle2>Subtitle 2</Subtitle2>
    <Body1>Body 1</Body1>
    <Body2>Body 2</Body2>
  </div>
)
